import { makeAutoObservable } from 'mobx'
import type { StripeElementsOptionsMode } from '@stripe/stripe-js'
import { ShopRootStore } from 'shop/stores/shopRoot.store'
import { STIPE_ELEMENT_OPTIONS_DEFAULT } from 'constants/paymentSettingShared.constants'

import {
  StripeElementOptions,
  StripeElementsPayloads,
  StripePaymentElement,
} from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopStripeSepaPaymentMethodStore implements StripePaymentElement, StripeElementOptions {
  storeName = 'ShopStripeSepaPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
  }): StripeElementsOptionsMode => {
    let store: StripeElementsPayloads = null

    if (isDealsPage) {
      store = this.root.dealsStore
    } else if (isManagePage) {
      store = this.root.ordersStore
    } else {
      store = this.root.paymentStore
    }

    return (store?.getSepaStripeElementPayload && store.getSepaStripeElementPayload()) || STIPE_ELEMENT_OPTIONS_DEFAULT
  }

  getPaymentElementOptions = () => ({
    fields: {
      billingDetails: 'never',
    },
  })
}
